<template>
  <TournamentScheduleSeniForm />
</template>
  
<script>
  import TournamentScheduleSeniForm from '@/components/tournament-schedule/TournamentScheduleSeniForm.vue';
  
  export default {
    name: "TournamentScheduleSeniCreatePage",
    components: {
      TournamentScheduleSeniForm,
    },
  };
</script>
  